import { NgModule } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';

@NgModule({
  imports: [MatProgressBarModule],
  exports: [MatProgressBarModule]
})
export class TiimeProgressBarModule {}
